// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"c5674ad5","171":"ac2bcacb","282":"195d1bff","361":"83ed6530","453":"b653dc3c"}[chunkId] + ".chunk.js";
};